import script from "./LeaderProjectAgreementWarning.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaderProjectAgreementWarning.vue?vue&type=script&setup=true&lang=js"

import "./LeaderProjectAgreementWarning.vue?vue&type=style&index=0&id=74749c78&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74749c78"]])

export default __exports__